import type { OnDestroy, OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import type { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import type { Subscription } from 'rxjs';
import { Jotform } from './jotform.service';
import type { JotformQueryParams } from './jotform.types';

@Component({
  standalone: false,
  selector: 'fl-jotform',
  template: ` <iframe
    class="JotForm"
    allowtransparency="true"
    allowfullscreen="true"
    frameborder="0"
    [id]="formId"
    [title]="titleText"
    [src]="jotformSrc"
  >
  </iframe>`,
  styleUrls: ['./jotform.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JotformComponent implements OnInit, OnDestroy {
  @Input() formId: string;
  @Input() formName: string;
  @Input() titleText: string;
  @Input() queryParameters: readonly JotformQueryParams[] = [];

  @Input() set height(value: number) {
    this.frameHeight = `${value}px`;
  }

  @HostBinding('style.--iframe-height')
  frameHeight = '250px';

  private jotformQueryParamSubscription?: Subscription;
  jotformSrc: SafeResourceUrl;

  constructor(
    private jotform: Jotform,
    private routes: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const alphaNumericRegExp = /^[a-zA-Z0-9_-]+$/;
    this.queryParameters = [
      ...this.queryParameters,
      {
        urlParam: 'gclid',
        jotformParam: 'gclid',
        validFormat: alphaNumericRegExp,
      },
      {
        urlParam: 'gclid',
        jotformParam: 'fbclid',
        validFormat: alphaNumericRegExp,
      },
      {
        urlParam: 'gclid',
        jotformParam: 'msclkid',
        validFormat: alphaNumericRegExp,
      },
    ];

    this.jotformQueryParamSubscription = this.routes.queryParams.subscribe(
      currentParameters => {
        const urlSearchParams = new URLSearchParams();
        this.queryParameters.forEach(queryParam => {
          if (currentParameters[queryParam.urlParam]) {
            if (
              (queryParam.validFormat &&
                queryParam.validFormat.test(
                  currentParameters[queryParam.urlParam],
                )) ||
              queryParam.validFormat === undefined
            ) {
              urlSearchParams.append(
                queryParam.jotformParam,
                currentParameters[queryParam.urlParam],
              );
            }
          }
        });

        this.jotformSrc = this.jotform.getJotformUrl(
          this.formName,
          urlSearchParams.toString(),
        );
      },
    );
  }

  ngOnDestroy(): void {
    this.jotformQueryParamSubscription?.unsubscribe();
  }
}
